module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Incoming-call-251fa404928135164a7a7111c175dd45.svg";